









import Vue from 'vue'

export default Vue.extend({
  name: 'InfoUser',
  props: ["data"],
  components: {
  }
})
